


















































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import mapLoader from "../../../lib/loadMap";
@Component
export default class aMaps extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: String }) mapid: string;
  formmap = {
    addr: "",
    longitude: "",
    latitude: "",
  };
  map: any;
  placeSearch: any;
  Amapy: any;
  cancel() {
    this.$emit("input", false);
  }
  saveAmap() {
      this.$emit('child-event',this.formmap.longitude,this.formmap.latitude);
      this.$emit("input", false);
  }
  selAddr() {
    let that = this;
    if (this.formmap.addr != "") {
      this.placeSearch.search(this.formmap.addr, function (status, result) {
        // 查询成功时，result即对应匹配的POI信息
        //console.log(result);
        var pois = result.poiList.pois;
        for (var i = 0; i < pois.length; i++) {
          var poi = pois[i];
          var marker = [];
          marker[i] = new that.Amapy.Marker({
            position: poi.location, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            title: poi.name,
          });
          // 将创建的点标记添加到已有的地图实例：
          that.map.add(marker[i]);
        }
        that.map.setFitView();
      });
    }
  }
  async creatMap() {
     
    let that = this;
    await mapLoader()
      .then(async (AMap: any) => {
        //console.log("MP加载。。then。。。", AMap);

        // if (!(window as any).AMapUI) {
        //   // 如果还没有初始化
        //   await initAMapUI(); // 这里调用initAMapUI初始化
        // }
        //加载地图
        that.map = new AMap.Map(that.mapid, {
          center: [105.612976, 38.168153],
          zoom: 4,
        });
        that.pickuplocation(AMap);
         //console.log(111);
      })
      .catch((err) => {
        console.log("MP加载。。err。。。", err);
      });
  }
  pickuplocation(AMap) {
    let that = this;
    this.map.on("click", function (e) {
      that.formmap.longitude = e.lnglat.getLng();
      that.formmap.latitude = e.lnglat.getLat();
    });
    this.placeSearch = new AMap.PlaceSearch({
      // city 指定搜索所在城市，支持传入格式有：城市名、citycode和adcode
      city: "021",
    });
    this.Amapy = AMap;
  }
  visibleChange(value: boolean) {
    this.creatMap();
  }
  mounted() {}
  created() {}
}
